import _msp_fn from '@shared/msp/funzioni.js';
import _msp_api from '@shared/msp/api.js';
import LZString from 'lz-string';
import _localStorage from '@src/js/msp/localStorage.js';
import _clipboard from '@src/js/msp/clipboard.js';



const _storage = {};
_storage.localStorage = _localStorage;

_storage.clipboard = _clipboard;

_storage.history = {
  limit: 5,
  push: function  (obj)
  {
    let history = _storage.history.load();
    if (!history)
    {
      history = [];
    }
    if (history.length < _storage.history.limit)
    {

      history.push(obj);
    }
    else {
      history.splice(_storage.history.limit-1,1,obj);
    }

    let string = JSON.stringify(history);
    let compressed = LZString.compressToUTF16(string);
    _storage.localStorage.set('history', compressed);
  },
  load: function  ()
  {
    let compressed = _storage.localStorage.get('history');
    // controlla vecchi storage in formato json
    if (_msp_fn.isValidJSON(compressed))
    {
      return JSON.parse(compressed) || [];
    }

    // se non esiste...
    if (!compressed)
    {
      return [];
    }

    let history = LZString.decompressFromUTF16(compressed);
    return JSON.parse(history) || [];
  },
  fetch: function  (index)
  {
    let history = _storage.history.load();
    return  history && (history.length > index + 1) && history[index] || false;
  },
  clear: function  ()
  {
    _storage.localStorage.remove('history');
  },
  count: function ()
  {
    let history = _storage.history.load();
    return history && history.length;
  },
  isEmpty: function ()
  {
    return !_storage.localStorage.get('history');
  },
}

_storage.storage = {};
_storage.vue = {};



_storage.getIdAtleta = function () {
  let account = _storage.getAccount();
  return account && account.atleta_id;
}
_storage.getAccount = function () {
  let account = _storage.localStorage.getJSON('account') || false;
  let types = ['atleta','gruppo'];

  if (account && (types.indexOf(account.type)!==-1))
  {
    return account;

  }
  else
  {
    return false;
  }
}

_storage.fetchIdAtleta = async function () {
  let atleta = await _msp_api.get("atleta.php?my_id", "/api/v2");
  if (atleta.success) {
    return +atleta.data;
  } else {
    return false;
  }
}

_storage.setIdAtleta = function () {
  return false;
}
_storage.setAccount = function (account) {
  _storage.localStorage.setJSON('account', account);

}


_storage.vue = {
  fns: [],
  ready: function (fn)
  {
    this.fns.push(fn);
  },
  isReady: function ()
  {
    this.fns.forEach(fn=>{fn();});
  }
}

export { _storage as default };
